// extracted by mini-css-extract-plugin
export default {"wrapper":"MItTRjNMhmvcEK9SMZn5","message":"ANSKFoEzjrjtdGiraQCR","close":"eWUimGY4UCQFxcXfWaua"};